<template>
  <CModal class="modal-chooseFile" title="Danh sách địa bàn" :show.sync="isShowModal" :closeOnBackdrop="false"
    :size="'xl'">
    <div id="locationModal" class="custom-scroll">
      <CCard class="content-fade-in">
        <CCardBody>
          <CRow class="mb-3 search-panel">
            <CCol xs="12" sm="4" md="4" lg="4" xl="3">
              <BaseSelect :options="provinceCodeInput.options" :data="provinceCodeInput.data" ref="provinceCodeInput">
              </BaseSelect>
            </CCol>
            <CCol xs="12" sm="4" md="4" lg="4" xl="3">
              <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data" ref="districtCodeInput">
              </BaseSelect>
            </CCol>
            <CCol xs="12" sm="4" md="4" lg="4" xl="3">
              <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
            </CCol>
            <CCol class="modal-refresh-col">
              <div class="form-group modal-refresh-group">
                  <CButton color="primary" v-c-tooltip.hover="'Tải lại'"
                    class="btn-action-primary" @click="reloadData()">
                  <i class="fa fa-refresh"></i>&nbsp;Tải lại
                </CButton>
              </div>
            </CCol>
          </CRow>

          <CDataTable class="custom-scroll" :items="mainTable.items" :fields="mainTable.options.fields" :sorter="true"
            :loading="loading.value" :sorterValue="{ column: null, asc: 'true' }"
            :tableFilter="{ label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false }"
            :itemsPerPageSelect="{ label: ' ', values: [10, 15, 20, 50], external: true }" :itemsPerPage="pagination.pageSize" :clickableRows="true"
            :hover="true" @pagination-change="changeItemPerPage" @row-clicked="rowClickTable">
            <template #index="{ index, item }">
              <td class="action-btn-group">
                <CInputRadio
                  type="radio"
                  addInputClasses="override-custom"
                  custom
                  :value="item.id"
                  name="locationSelected"
                  :key="'loc-radio-' + item.id + '-' + String(selectionIdForCompare)"
                  :checked="isItemSelected(item)"
                />
              </td>
            </template>
            <template #action="{ item }">
              <td class="action-btn-group">
                <CInputRadio type="radio" addInputClasses="override-custom" custom :value="item.id" name="test"
                  :checked="item.checked" />
              </td>
            </template>
            <template #sourceId="{ item }">
              <td>
                <span :key="'sourceId' + item.id + item.sourceId" class="description">
                  {{ !item.sourceId ? "" : item.sourceId }}
                </span>
              </td>
            </template>
            <template slot="no-items-view">
              <span style="color: #969696">Danh sách trống!</span>
            </template>
            <template slot="loading">
              <BaseFormLoading :loading="true"></BaseFormLoading>
            </template>
          </CDataTable>

          <div v-if="pagination && pagination.totalElement !== 0">
            <div style="display:flex; flex-wrap:wrap;">
              <div style="font-size:.95em;color:gray; padding-left:.75rem;">
                {{ fromElement }}-{{ toElement }} /
                {{ pagination.totalElement }} bản ghi
              </div>
              <nav style="margin-left:auto;">
                <CPagination @update:activePage="updateActivePage" :activePage.sync="pagination.activePage"
                  :pages="pagination.pages" :total-rows="pagination.totalRows" :per-page="pagination.pageSize"
                  prev-text="Prev" next-text="Next" hide-goto-end-buttons />
              </nav>
            </div>
          </div>
        </CCardBody>
      </CCard>

    </div>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary" :disabled="itemChooseSelected == ''" @click="submitSelectedChoose()">
        <i class="fa fa-check"></i> Chọn
      </button>
      <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
      </button>
    </template>
  </CModal>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import { DatePicker } from "v-calendar";

export default {
  name: "BaseLocationModal",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
  },
  props: {
    /** Current location row id from parent (Nguồn ID / Đích ID) — used to pre-select radio when reopening */
    selectedLocationId: {
      default: null,
    },
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      isShowModal: true,
      loading: {
        value: false,
      },
      provinceCodeInput: {
        options: {
          filter: true,
          label: "Tỉnh/Thành phố",
          selectAllText: "Tất cả Tỉnh/Thành phố",
          'keyField': 'key',
          'valueField': 'value'
        },
        data: {
          name: "provinceCode",
          items: [],
          model: null,
          source: {
            url: '/location/get-list-location',
            dataSubmit: function () {
              return {
                level: 0
              }
            },
            response: function (dataResponse) {
              that.provinceCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value'
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/location/get-list-location',
            dataSubmit: function () {
              const provinceCode = that.normalizeFilterValue(that.provinceCodeInput.data.model);
              return {
                parentCode: provinceCode,
                level: 1
              }
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value'
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/location/get-list-location',
            dataSubmit: function () {
              const districtCode = that.normalizeFilterValue(that.districtCodeInput.data.model);
              return {
                // Ward list is driven by district filter only.
                // If district is "Tất cả", send null to get full ward scope from backend.
                parentCode: districtCode,
                level: 2
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "#", sorter: false, filter: false },
            { key: "sourceId", label: "Mã định danh" },
            { key: "name", label: "Tên địa bàn" },
            { key: "code", label: "Mã địa bàn" },
            // {key: "pathLocation", label: "Cây địa bàn"},
          ],
          slots: [
            "index", "sourceId"
          ],
          sorter: true,
          columnFilter: false,
        },
        items: [],
      },
      pagination: {
        activePage: 1,
        pages: 1,
        pageSize: 20,
        totalElement: 0,
        totalRows: 0
      },
      itemChooseSelected: '',
      loadSeq: 0,
      reloadTimer: null
    };
  },
  methods: {
    normalizeFilterValue(value) {
      return (value === null || value === undefined || value === '') ? null : String(value);
    },
    loadData(resetSelection = false) {
      let that = this;
      const currentSeq = ++that.loadSeq;
      that.loading.value = true;
      if (resetSelection) {
        that.itemChooseSelected = '';
      }

      that.$helper.loadDataSource({
        url: "/location/get-list",
        dataSubmit: function () {
          return {
            pageSize: that.pagination.pageSize,
            pageNumber: that.pagination.activePage - 1,
            locationCode: that.locationCode && that.locationCode.data ? that.locationCode.data.model : null
          };
        },
        successCallback: function (response) {
          if (currentSeq !== that.loadSeq) {
            return;
          }
          try {
            if (that.$helper.validResponse(that.$router, response.data)) {
              that.mainTable.items = [];
              let _data = response.data.data;
              let isFoundSelected = false;
              const content = (_data && _data.dataContent && _data.dataContent.content) ? _data.dataContent.content : [];
              const selId =
                that.itemChooseSelected &&
                that.itemChooseSelected !== "" &&
                that.itemChooseSelected.id !== undefined &&
                that.itemChooseSelected.id !== null &&
                that.itemChooseSelected.id !== ""
                  ? that.itemChooseSelected.id
                  : null;
              content.map((each) => {
                const match =
                  selId !== null && String(each.id) === String(selId);
                if (match) {
                  isFoundSelected = true;
                  that.itemChooseSelected = each;
                }
                that.mainTable.items.push(each);
              });
              if (!isFoundSelected) {
                that.itemChooseSelected = '';
              }
              that.setupPagination(_data || { totalElement: 0 });
              that.isShow = true;
            }
          } catch (e) {
            that.mainTable.items = [];
            that.itemChooseSelected = '';
            that.setupPagination({ totalElement: 0 });
          }
          that.loading.value = false;
        },
        errorCallback: function (error) {
          if (currentSeq !== that.loadSeq) {
            return;
          }
          that.loading.value = false;
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    reloadData() {
      this.pagination.activePage = 1;
      this.loadData(true);
    },
    scheduleReload() {
      if (this.reloadTimer) {
        clearTimeout(this.reloadTimer);
      }
      this.reloadTimer = setTimeout(() => {
        this.reloadTimer = null;
        this.reloadData();
      }, 0);
    },
    updateActivePage: function (activePage) {
      this.pagination.activePage = activePage;
      this.loadData();
    },
    setupPagination(_dataResponse) {
      this.pagination.pages = Math.ceil(_dataResponse.totalElement / this.pagination.pageSize);
      this.pagination.totalElement = _dataResponse.totalElement;
    },
    rowClickTable(item) {
      this.itemChooseSelected = item;
    },
    applyPreselectedLocation() {
      const sid = this.selectedLocationId;
      if (sid !== null && sid !== undefined && sid !== "") {
        this.itemChooseSelected = { id: sid };
      }
    },
    isItemSelected(item) {
      const sid = this.selectionIdForCompare;
      return (
        sid !== null &&
        sid !== undefined &&
        sid !== "" &&
        String(item.id) === String(sid)
      );
    },
    submitSelectedChoose() {
      if (this.itemChooseSelected == null || this.itemChooseSelected == '') {
        return;
      }
      this.$emit('item:selected', this.itemChooseSelected);
    },
    changeItemPerPage(value) {
      this.pagination.activePage = 1;
      this.pagination.pageSize = value;
      this.loadData();
    },
  },
  created: function () {
  },
  mounted() {
    this.applyPreselectedLocation();
    this.pagination.activePage = 1;
    this.loadData(false);
  },
  watch: {
    isShowModal: function (value) {
      if (!value) {
        this.$emit("close-modal", false);
      }
    },
    'provinceCodeInput.data.model': function (value, oldValue) {
      if (typeof oldValue === "undefined") return;
      if (this.normalizeFilterValue(value) === this.normalizeFilterValue(oldValue)) return;
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = null;
      }
      this.districtCodeInput.data.model = null
      this.districtCodeInput.data.items = [];
      this.wardCodeInput.data.model = null
      this.wardCodeInput.data.items = [];
      // Do not rely on BaseSelect callback here; it is not re-bound on every load.
      this.$refs.districtCodeInput.loadData();
      this.$refs.wardCodeInput.loadData();
      this.scheduleReload();
    },
    'districtCodeInput.data.model': function (value, oldValue) {
      if (typeof oldValue === "undefined") return;
      if (this.normalizeFilterValue(value) === this.normalizeFilterValue(oldValue)) return;
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.provinceCodeInput.data.model;
      }
      this.wardCodeInput.data.model = null
      this.wardCodeInput.data.items = [];
      // "Tất cả Quận/Huyện" still loads wards by province/all.
      this.$refs.wardCodeInput.loadData();
      this.scheduleReload();
    },
    'wardCodeInput.data.model': function (value, oldValue) {
      if (typeof oldValue === "undefined") return;
      if (this.normalizeFilterValue(value) === this.normalizeFilterValue(oldValue)) return;
      if (value) {
        this.locationCode.data.model = value;
      } else {
        if (this.districtCodeInput.data.model) {
          this.locationCode.data.model = this.districtCodeInput.data.model;
        } else {
          this.locationCode.data.model = this.provinceCodeInput.data.model;
        }
      }
      this.scheduleReload();
    }
  },
  computed: {
    /** Prefer row selection; else id from parent so radio shows before/without row flags */
    selectionIdForCompare() {
      const chosen = this.itemChooseSelected;
      if (
        chosen &&
        chosen !== "" &&
        chosen.id !== undefined &&
        chosen.id !== null &&
        chosen.id !== ""
      ) {
        return chosen.id;
      }
      const sid = this.selectedLocationId;
      if (sid !== null && sid !== undefined && sid !== "") {
        return sid;
      }
      return null;
    },
    fromElement: function () {
      return (this.pagination.activePage - 1) * this.pagination.pageSize + 1;
    },
    toElement: function () {
      return (
        (this.pagination.activePage - 1) * this.pagination.pageSize +
        this.mainTable.items.length
      );
    },
  },
};
</script>

<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style lang="scss">
#locationModal {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;

  .card,
  .card-body {
    margin-bottom: 0 !important;
  }

  .form-check-input {
    width: 16px;
    height: 16px;
  }

  .modal-refresh-col {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }

  .modal-refresh-group {
    width: 100%;
    margin-bottom: 0.35rem;
    display: flex;
    justify-content: flex-end;
  }
  
  .custom-control-input {
    opacity: 0 !important;
  }
}

@media (max-width: 991px) {
  #locationModal {
    max-height: calc(100vh - 240px);
  }
}

@media (max-width: 576px) {
  #locationModal {
    max-height: calc(100vh - 210px);
  }
}
</style>
